module.exports = __webpack_public_path__ + "img/product-type-item-bg-active.fef9addc.png";